import api from "./api";

export async function fetchWorkorderStats(params = {}) {
  const res = await api.get("/workorders/stats", { params });
  return res?.data?.data || { total: 0, statuses: [] };
}

export async function fetchProjectStats(params = {}) {
  const res = await api.get("/projects/stats", { params });
  return res?.data?.data || { total: 0, statuses: [] };
}
